import { DecisionState } from "../../models/home";
import { UxError } from "../../models/ux-error.model";
import { HomeStreamEventType } from "../../services/home-ia/home-stream.service";

export interface LoadState<T> {
  data: T | null;
  loading: boolean;
  error: UxError | null;
  empty: boolean;
  lastUpdated?: number | null;
  stale?: boolean;
}

export interface PendingActionEchoContext {
  decisionId: string;
  clientTraceId?: string;
  activityId?: string;
  expiresAt: number;
  suppressedEvents: Set<HomeStreamEventType>;
}

export type DecisionStateFilter = DecisionState | "all" | "attention";

/** Bucket "atención" = estados accionables (P1-3). Se envía al backend como CSV en `state`. */
export const ATTENTION_STATE_CSV = "act_now,act_soon,act_without_rush";

/**
 * Proyecta el filtro de estado de la UI al valor `state` de la petición.
 * "all" → sin filtro; "attention" → CSV de estados accionables; resto → el estado tal cual.
 */
export function projectDecisionStateParam(filter: DecisionStateFilter): string | undefined {
  if (filter === "all") return undefined;
  if (filter === "attention") return ATTENTION_STATE_CSV;
  return filter;
}
export type HomeAutoRefreshTarget = "pulse" | "overview" | "next" | "list" | "calendar" | "detail" | "dates" | "activity" | "metrics";
